// extracted by mini-css-extract-plugin
export var active = "IconAccordionItem-module--active--125cf";
export var content = "IconAccordionItem-module--content--3b816";
export var header = "IconAccordionItem-module--header--dd5a0";
export var hidden = "IconAccordionItem-module--hidden--2e7df";
export var icon = "IconAccordionItem-module--icon--d9b4b";
export var item = "IconAccordionItem-module--item--34f8f";
export var titleContainer = "IconAccordionItem-module--titleContainer--6cf32";
export var toggle = "IconAccordionItem-module--toggle--50034";